import { Component, EventEmitter, HostListener, OnInit, Output } from "@angular/core";
import { Order } from "../../../objects/orders/order";
import { PaginationInstance } from "ngx-pagination";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../../services/orderService";
import { Location } from '@angular/common';
import { CustomerService } from "../../../services/customerService";
import { UserService } from "../../../services/userService";
import { BaseOrderManagement } from "./baseOrderManagement";
import { ConfigService } from "../../../services/configService";
import { OrderViewType } from "../../../objects/management/order/orderViewType";
import { StorageManager } from "../../../common/managers/storageManager";
import { OrderStatus } from "../../../objects/orders/orderStatus";
import { UserViewService } from "../../../services/userViewService";
import { Component as ComponentEnum } from "../../../objects/components/component";
import { Customer } from "../../../objects/customers/customer";
import { UserViewConfig } from "../../../objects/users/user";
import { OrderBy, Query } from "ngx-odata-v4";
import { Http, Headers } from "@angular/http";
import { OrderODataService } from "../../../services/orderOData.service";
import { ScreenHelper } from "../../../common/helpers/screenHelper";


/**
 * Created by alex.y on 9/13/2017.
 */

@Component({
    selector: 'order',
    templateUrl: 'orderManagement.component.html',
    moduleId: module.id.toString().trim(),
    host: {
        '(window:resize)': 'onResize($event)'
    }
})
export class OrderManagementComponent extends BaseOrderManagement implements OnInit {

    public orders: Order[] = [];


    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    public orderViewType = OrderViewType;
    public orderStatus = OrderStatus;
    public componentEnum = ComponentEnum;

    public idToBlur: string = "customer-management";

    public userView: any;

    private isMobileScreen: boolean;


    constructor(private route: ActivatedRoute, public orderService: OrderService, public location: Location, public customerService: CustomerService
        , public userService: UserService, private router: Router, private configService: ConfigService, public storageManager: StorageManager,
                public userViewService: UserViewService, public http: Http, public orderODataService: OrderODataService) {
        super(orderService, location, customerService, userService, storageManager, userViewService, orderODataService);
    }
    @HostListener("window:resize")
    public onResize(event: any): void {
        let userView = this.userViewService.userView[ComponentEnum.OrderManagement];
        if(this.isMobileScreen == this.isMobileView || userView.ViewType == OrderViewType.Tile)
            return;

        if(this.isMobileView){
            userView.ViewType = OrderViewType.Tile;
            this.updateColumns(true);
        }

        this.isMobileScreen = this.isMobileView;
    }

    public ngOnInit(): void {
        this.config.totalItems = this.route.snapshot.data.userViewOrder.orders.TotalCount;
        this.orders = this.route.snapshot.data.userViewOrder.orders.Items;

        this.route.params.subscribe(params => {
            let email = params['customeremail'];
            let query = params['query'];
            let agentId = params['agentid'];
            let customerId = params['customerid'];

            if (email)
                this.query = email;

            if (query)
                this.query = query;

            if (agentId)
                this.agentId = agentId;

            if (customerId)
                this.customerId = customerId;
        });

        this.updateColumns();

    }

    public get isMobileView(): boolean{
        return  ScreenHelper.isPhone();
    }

    public createEvent(): void {
        this.router.navigate(["calculator/agent"]);
    }

    public toggleView(): void {
        let userView = this.userViewService.userView[ComponentEnum.OrderManagement];
        if (userView.ViewType == OrderViewType.Table)
            userView.ViewType = OrderViewType.Tile;
        else
            userView.ViewType = OrderViewType.Table;

        this.isViewLoading = true;
        this.orders = [];
        this.userViewService.updateUserView(new UserViewConfig({
            Id: userView.Id,
            UserId: this.currentUser.Id,
            ComponentId: ComponentEnum.OrderManagement,
            ViewType: userView.ViewType
        })).then(x => {
            if (!x.Data)
                return;

            userView.Id = x.Data.Id;

            this.updateColumns();
            this.config.currentPage = 1;
            this.search(this.agentId == null);
        });
    }

    public updateColumns(refreshOrders: boolean = false): void {
        this.tableColumns = this.getColumns();

        if(refreshOrders)
            this.search();
    }

    public handleTableSearch(resetPage: boolean = false): void {
        if(resetPage == true){
            this.config.currentPage = 1;
        }

        this.search(this.agentId == null, '/management/order', !resetPage, !resetPage)
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderManagement.component.ts